import { __awaiter, __generator } from "tslib";
import { getParamFromWindow } from '@office-start/window-utility';
export function applyOfficeIdentity(requestConfig, inMockMode, workload, getIdentity) {
    return __awaiter(this, void 0, void 0, function () {
        var flightOverrides, identity, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!requestConfig.params) {
                        requestConfig.params = {};
                    }
                    requestConfig.params["workload" /* Workload */] = workload;
                    flightOverrides = getParamFromWindow("flight" /* Flight */);
                    if (flightOverrides) {
                        requestConfig.params["flight" /* Flight */] = flightOverrides;
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getIdentity()];
                case 2:
                    identity = _b.sent();
                    if (identity) {
                        if (!requestConfig.headers) {
                            requestConfig.headers = {};
                        }
                        requestConfig.headers["X-OfficeHome-UserId" /* UserId */] = identity.puid;
                        requestConfig.headers["X-OfficeHome-TenantId" /* TenantId */] = identity.tenantId;
                        requestConfig.params[inMockMode ? "mockauth" /* MockAuth */ : "auth" /* Auth */] = identity.isMsa ? '1' : '2';
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, requestConfig];
            }
        });
    });
}
//# sourceMappingURL=applyOfficeIdentity.js.map